<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = ["data-touched", "data-playing", "data-paused", "data-waiting", "data-idle", "data-hover"];
const _hoisted_2 = { class: "magic-player-audio-controls__bar" };
const _hoisted_3 = {
  class: "magic-player-audio-controls__item -shrink-0",
  "data-slot": "play-toggle"
};
const _hoisted_4 = {
  class: "magic-player-audio-controls__item -shrink-0",
  "data-slot": "display-time-current"
};
const _hoisted_5 = {
  class: "magic-player-audio-controls__item -grow",
  "data-slot": "timeline"
};
const _hoisted_6 = {
  class: "magic-player-audio-controls__item -shrink-0",
  "data-slot": "display-time-duration"
};
import { computed, ref, inject, provide } from "vue";
import { useIdle } from "@vueuse/core";
import { usePlayerMediaApi } from "../composables/private/usePlayerMediaApi";
import { usePlayerAudioApi } from "../composables/private/usePlayerAudioApi";
import { usePlayerControlsApi } from "../composables/private/usePlayerControlsApi";
import IconPlay from "./icons/Play.vue";
import IconPause from "./icons/Pause.vue";
import { MagicPlayerInstanceId } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerAudioControls",
  props: {
    id: { type: String, required: false }
  },
  setup(__props) {
    const instanceId = inject(MagicPlayerInstanceId, void 0);
    const mappedId = computed(() => __props.id ?? instanceId);
    if (!mappedId.value) {
      throw new Error(
        "MagicAudioPlayerControls must be nested inside MagicAudioPlayer or be passed an id as a prop."
      );
    }
    const barRef = ref(void 0);
    const trackRef = ref(void 0);
    const { playing, waiting } = usePlayerMediaApi({
      id: mappedId.value
    });
    const { play, pause, touched, mouseEntered } = usePlayerAudioApi({
      id: mappedId.value
    });
    usePlayerControlsApi({
      id: mappedId.value,
      barRef,
      trackRef
    });
    const { idle } = useIdle(3e3);
    provide(MagicPlayerInstanceId, mappedId.value);
    return (_ctx, _cache) => {
      const _component_magic_player_display_time = _resolveComponent("magic-player-display-time");
      const _component_magic_player_timeline = _resolveComponent("magic-player-timeline");
      return _openBlock(), _createElementBlock("div", {
        class: "magic-player-audio-controls",
        "data-touched": _unref(touched),
        "data-playing": _unref(playing),
        "data-paused": !_unref(playing),
        "data-waiting": _unref(waiting),
        "data-idle": _unref(idle),
        "data-hover": _unref(mouseEntered)
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode(
            "div",
            {
              ref_key: "barRef",
              ref: barRef,
              class: "magic-player-audio-controls__bar--inner"
            },
            [
              _createElementVNode("div", _hoisted_3, [
                !_unref(playing) ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = //@ts-ignore
                  (...args) => _unref(play) && _unref(play)(...args))
                }, [
                  _renderSlot(_ctx.$slots, "playIcon", {}, () => [
                    _createVNode(IconPlay)
                  ])
                ])) : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = //@ts-ignore
                  (...args) => _unref(pause) && _unref(pause)(...args))
                }, [
                  _renderSlot(_ctx.$slots, "pauseIcon", {}, () => [
                    _createVNode(IconPause)
                  ])
                ]))
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_magic_player_display_time, { type: "current" })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode(
                  "div",
                  {
                    ref_key: "trackRef",
                    ref: trackRef,
                    class: "magic-player-audio-controls__timeline"
                  },
                  [
                    _createVNode(_component_magic_player_timeline)
                  ],
                  512
                  /* NEED_PATCH */
                )
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_magic_player_display_time, { type: "duration" })
              ])
            ],
            512
            /* NEED_PATCH */
          )
        ])
      ], 8, _hoisted_1);
    };
  }
});
</script>
